import { InspectionsReportPage } from "./InspectionsReportPage";

const InspectionsReport = () => {
	return <InspectionsReportPage />;
};

export default InspectionsReport;
